(ns net.kestec.mhda-pilgrimage.lib-ui.form-uploads
  (:require
    ["react-dropzone" :default Dropzone :refer [useDropzone]]
    ["@mui/icons-material/CloudUpload" :default CloudUploadIcon]
    ["@mui/icons-material/Delete" :default DeleteIcon]
    ["@mui/icons-material/InsertDriveFile" :default InsertDriveFileIcon]
    ["@mui/material/Button" :default Button]
    ["@mui/material/styles" :refer [styled]]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [day8.re-frame.http-fx]
    [net.kestec.re-frame.event :as event]
    ["react" :as react]
    [reagent.core :as r]
    ))




(def VisuallyHiddenInput
  ((styled "input")
   #js{:clip       "rect(0 0 0 0)"
       :clipPath   "inset(50%)"
       :height     1
       :width      1
       :overflow   "hidden"
       :position   "absolute"
       :bottom     0
       :left       0
       :whitespace "nowrap"}))

(defn default-alert-file-size [^js file limit]
  (js/alert (str "Too large File: " (.-name file) "\n\n"
                 (.toFixed (/ (.-size file) 1024 1024) 2) " MiB > "
                 (.toFixed (/ limit 1024 1024) 2) "MiB")))

(def DropzoneContext (react/createContext nil))

(defn file-upload-input* [{:keys        [accept multiple size-limit alert-file-size on-change]
                           :or          {accept          "application/pdf,image/*"
                                         size-limit      (* 50 1024 1024)
                                         alert-file-size default-alert-file-size
                                         multiple        true}}]
  ;; let [dzc (react/useContext DropzoneContext)]
  (react/createElement
    VisuallyHiddenInput
    (js/Object.assign
      #js{}
      #_(if dzc
          (.getInputProps dzc)
          #js{})
      #js{:type     "file"
          :multiple multiple
          :accept   accept
          :onChange (fn [^js evt]
                      (if-let [f (some #(and (> (.-size %) size-limit)
                                             %)
                                       (.. evt -target -files))]
                        (do
                          (set! (.. evt -target -value) #js[])
                          (alert-file-size f size-limit))
                        (-> (.. evt -target -files)
                            (cond-> (not multiple) (aget 0))
                            (->> (event/dispatch on-change)))))})))

(defn file-upload
  [label
   & {:as   props
      :keys [icon]
      :or   {icon [:> CloudUploadIcon]}}]
  [:> Button {:component "label"
              :role      js/undefined
              :tabIndex  -1
              :variant   "contained"
              :startIcon (r/as-element icon)}
   label
   [:f> file-upload-input* props]])

(defn file-upload-dropzone*
  [& {:keys        [content multiple]
      ::event/keys [on-drop]}]
  (let [onDrop (react/useCallback (fn [^js accepted-files]
                                    (event/dispatch on-drop (if multiple
                                                              accepted-files
                                                              (first accepted-files)))))
        dropzone-state (useDropzone #js{:onDrop onDrop})]
    [:> DropzoneContext {:value dropzone-state}
     (react/createElement
       "div"
       (js/Object.assign (.getRootProps dropzone-state)
                         #js{:style
                             #js{:position "relative"}})
       (r/as-element
         [:<>
          content
          (when (.. dropzone-state -isDragActive)
            [:div {:style {:position         "absolute"
                           :top              0 :left 0 :bottom 0 :right 0
                           :background-color "rgba(0,0,0,0.1)"}}])]))]))

(defn file-upload-dropzone [& args]
  (into [:f> file-upload-dropzone*] args))